<script setup lang="ts">
import {computed} from 'vue';
import {formatFte, KLEUR_BALK, StatusBalk, statusTekst} from 'common';

const props = defineProps<{
    balk: StatusBalk;
}>();

const breedte = computed<number>(() => Math.min(100, Math.max(0, (props.balk.ratio ?? 0) * 100)));
</script>

<template>
    <div class="flex flex-row items-center gap-4">
        <div class="w-48 text-sm">{{ balk.label }}</div>
        <div class="flex-1 h-3 rounded bg-gray-200 overflow-hidden">
            <div class="h-3 rounded" :style="{width: `${breedte}%`, backgroundColor: KLEUR_BALK[balk.kleur]}"/>
        </div>
        <div class="w-80 text-sm">
            <b>{{ formatFte(balk.waarde) }}</b>
            <span class="text-gray-500"> target {{ balk.target === undefined ? 'n.v.t.' : formatFte(balk.target) }} - {{ statusTekst(balk.kleur) }}</span>
        </div>
    </div>
</template>
